const API_URL = "https://api.rooms.sjcac.org";

export default API_URL;